import React, { useState } from "react";
import { Link } from "react-router-dom";

import RecordManagerModal from "./RecordManagerModal";
import { RecordKindConfig } from "./types";
import { useRecordPermissions } from "./useRecordPermissions";

/**
 * The "Edit" link in a profile section's header and the record manager it
 * opens. Shown to anyone who may add, edit or remove that kind of record.
 */
const ManageRecordsLink = ({
  owner,
  ownerName,
  config,
  refresh,
}: {
  owner: any;
  /** How the profile is named in empty states, e.g. the contractor's name. */
  ownerName?: string;
  config: RecordKindConfig;
  /** Reloads the profile so the list and the page show the change. */
  refresh: () => Promise<any>;
}) => {
  const { canManage } = useRecordPermissions(config);
  const [isOpen, setIsOpen] = useState(false);

  if (!canManage) return null;

  return (
    <>
      <Link
        to="#"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsOpen(true);
        }}
        className="link-primary link-offset-2 text-decoration-underline link-underline-opacity-25 link-underline-opacity-100-hover me-3"
      >
        <i className="ri-pencil-line"></i> Edit
      </Link>
      {/* React bubbles portal events through the component tree, so clicks in
          the modal would otherwise reach the card header and collapse it. */}
      <span onClick={(e) => e.stopPropagation()}>
        <RecordManagerModal
          isOpen={isOpen}
          toggle={() => setIsOpen(false)}
          owner={owner}
          ownerName={ownerName}
          config={config}
          refresh={refresh}
        />
      </span>
    </>
  );
};

export default ManageRecordsLink;
